import { formatCurrency, type LineMoney } from '@peles/shared';
import { StatusBadge } from '../../common/EntityList';
import { INSTALLMENT_STATE_COLORS, INSTALLMENT_STATE_LABELS, shortDate } from './moneyDisplay';

/**
 * A line's schedule with its payments applied oldest first: each installment,
 * its day, what is left on it and where it stands. Read-only; the editor is
 * `InstallmentEditor`.
 */
export function ScheduleList({ money, compact = false }: { money: LineMoney; compact?: boolean }) {
  return (
    <ul
      className={`divide-y divide-gray-100 rounded-md border border-gray-200 ${compact ? 'text-xs' : 'text-sm'}`}
    >
      {money.installments.map((i, index) => (
        <li
          key={i.id ?? `single-${index}`}
          className="flex flex-wrap items-center justify-between gap-2 px-3 py-2"
        >
          <span className="min-w-0">
            <span className="font-medium text-gray-900">{i.label || `Payment ${index + 1}`}</span>
            <span className="text-gray-500 ml-2">
              {i.dueDate ? `due ${shortDate(i.dueDate)}` : 'no due date'}
            </span>
          </span>
          <span className="flex items-center gap-2">
            <span className="text-gray-700">
              {formatCurrency(i.amount)}
              {i.state === 'partly_paid' || (i.state === 'overdue' && i.paid > 0)
                ? ` · ${formatCurrency(i.remaining)} left`
                : ''}
            </span>
            <StatusBadge
              label={INSTALLMENT_STATE_LABELS[i.state]}
              color={INSTALLMENT_STATE_COLORS[i.state]}
            />
          </span>
        </li>
      ))}
    </ul>
  );
}
